import { useEffect } from 'react';
import './dvh-fallback.scss';

export const useDvhFallback = () => {
  useEffect(() => {
    const isDvhSupported = getComputedStyle(document.documentElement)
      .getPropertyValue('--dvh')
      .includes('dvh');

    if (isDvhSupported) {
      return;
    }

    const handleResize = () => {
      const visualVh = window.visualViewport?.height || window.innerHeight;
      document.documentElement.style.setProperty('--dvh', `${visualVh}px`);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
    handleResize();
  }, []);
};
